<template>
  <router-link :to="navigateTo" class="ticket-item">
    <div class="icon-wrap">
      <fluent-icon icon="briefcase" :size="14" />
    </div>
    <div class="ticket-details">
      <div class="meta-wrap">
        <woot-label
          class="ticket-id"
          :title="`#${id}`"
          :show-close="false"
          small
        />
        <span class="created-at">{{ createdAtTime }}</span>
      </div>
      <h5 v-if="title" class="text-block-title name">
        {{ title }}
      </h5>
      <span v-if="contactName" class="contact-name">{{ contactName }}</span>
    </div>
  </router-link>
</template>

<script>
import { frontendURL } from 'dashboard/helper/URLHelper.js';
import timeMixin from 'dashboard/mixins/time';

export default {
  mixins: [timeMixin],
  props: {
    id: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    contactName: {
      type: String,
      default: '',
    },
    accountId: {
      type: [String, Number],
      default: '',
    },
    createdAt: {
      type: [String, Date, Number],
      default: '',
    },
  },
  computed: {
    // Leva ao quadro do CRM e sinaliza qual oportunidade abrir (?opportunity=<id>).
    navigateTo() {
      return frontendURL(`accounts/${this.accountId}/crm`, {
        opportunity: this.id,
      });
    },
    createdAtTime() {
      return this.createdAt ? this.dynamicTime(this.createdAt) : '';
    },
  },
};
</script>

<style scoped lang="scss">
.ticket-item {
  cursor: pointer;
  display: flex;
  padding: var(--space-small);
  border-radius: var(--border-radius-small);

  &:hover {
    background-color: var(--s-25);
  }
}

.meta-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-smaller);
}

.icon-wrap {
  width: var(--space-medium);
  height: var(--space-medium);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--w-600);
  border-radius: var(--border-radius-small);
  background-color: var(--w-75);
}

.ticket-details {
  margin-left: var(--space-small);
  flex-grow: 1;
  min-width: 0;
}

.ticket-id,
.name {
  margin: 0;
}

.contact-name,
.created-at {
  color: var(--s-600);
  font-size: var(--font-size-mini);
  font-weight: var(--font-weight-normal);
}
</style>
